import { Download } from "lucide-react";
import { Button } from "@themes/pollinator/ui/Button";
import { Image } from "@themes/pollinator/ui/Image";

export type Props = {
  /** Image source URL */
  src: string;
  /** Label to distinguish this post (e.g. "Post 1", "Story 3") */
  label: string;
  /** Optional Tailwind background class for the image area */
  background?: string;
};

/**
 * Displays a single social media post image with download button.
 */
export function OutreachPost({ src, label, background }: Props) {
  return (
    <div className="w-[calc(50%-0.5rem)] md:w-[calc(33.333%-1rem)] flex flex-col border rounded-md">
      <div className={`w-full ${background ? `p-4 ${background} rounded-t-md` : ""}`}>
        <Image
          src={src}
          alt={label}
          className="w-full object-contain rounded-t-md overflow-hidden"
        />
      </div>
      <div className="w-full p-4 border-t">
        <Button
          as="a"
          href={src}
          target="_blank"
          download
          variant="secondary"
          className="w-full"
          iconComponent={Download}
          aria-label={`Download ${label}`}
        >
          Download
        </Button>
      </div>
    </div>
  );
}

